<template>
<div class="devices-page">
  <h1 class="page-title">
    <span>Devices</span>

  </h1>

<b-tabs>
  <b-tab title="Devices" active @click="findAll">
    <template v-slot:title>
      <h6>Devices: <b-badge>{{ devices.length }}</b-badge></h6>
    </template>
    <div>

      <h4>Devices</h4>
      <ResponsiveTable
          :fields="fields"
          :items="devicesUnNested"
          :searchable_fields="searchableFields"
          sort-by="product_serial_num"
          sort-direction="asc"
      >
        <template v-slot:cell(product_serial_num)="row">
          <b-icon icon="circle-fill" :variant="row.item.online ? 'success' : 'danger'"/>
          &nbsp
          <router-link :to="{ name: 'DevicePage', params: { serial: row.item.serial, fromDevicePage: true }}">{{ row.item.product_serial_num }}</router-link>
        </template>
        <template v-slot:cell(circuit)="row">
          <router-link :to="{ name: 'DashboardPage' }">
            <span @click="setSelectedDevice(row.item.product_serial_num)">
                {{row.item.circuit}}
            </span>
          </router-link>
        </template>
        <template v-slot:cell(pole_substation_name)="row">
          {{row.item.pole ? row.item.pole.pole_substation_name : ''}}
        </template>
        <template v-slot:cell(actions)="row">
            <b-button
              v-if="$base.isAllowed('sentinelUpgrade')"
              class="actionButton"
              id="upgrade_button"
              v-b-modal="'deviceUpgradeModal'"
              variant="primary"
              size="sm"
              @click.prevent="setSelectedDeviceForSentinelUpgrade(row.item)">Upgrade</b-button>
            <b-button
              class="actionButton"
              id="upgrade_button"
              v-if="!row.item.pole && $base.isAllowed('installDevice')"
              v-b-modal="'sentinelInstallModal'"
              variant="primary"
              size="sm"
              @click.prevent="setSelectedDeviceForSentinelInstall(row.item)">Install</b-button>
            <b-button
              class="actionButton"
              id="upgrade_button"
              v-if="row.item.pole && $base.isAllowed('uninstallDevice')"
              v-b-modal="'UninstallationModal'"
              variant="primary"
              size="sm"
              @click.prevent="setSelectedDeviceForSentinelUninstall(row.item)">Uninstall</b-button>
        </template>
      </ResponsiveTable>
    </div>
  </b-tab>

  <b-tab title="Installation Issues" lazy @click="updateinstallationCounts">
    <template v-slot:title>
      <h6>Installation Issues: <b-badge>{{ installationIssuesCount }}</b-badge></h6>
    </template>
    <InstallationIssues />
  </b-tab>

  <b-tab title="Installation Log" lazy @click="updateinstallationCounts">
    <template v-slot:title>
      <h6>Installation Log: <b-badge v-b-tooltip.hover title="Installation events in last 30 days">{{ installationLogCount }}</b-badge></h6>
    </template>
    <InstallationLog />
  </b-tab>

</b-tabs>

  <DeviceUpgradeModal :device="deviceToUpgrade"/>
  <InstallationModal 
          title="Install LineSIGHT" id="sentinelInstallModal"
          refName="deviceInstallModal"
          :deviceToInstall="deviceToInstall"
          @modalReset="handleInstallModalReset"
  />
  <UninstallationModal :device="deviceToUninstall" @modalReset="handleUninstallModalReset" @uninstallSuccess="handleUninstallSuccess" />
</div>
</template>

<script>
import {
  mapGetters,
  mapActions, mapState
} from 'vuex';
import datetimeFormatter from '@/core/datetimeFormatterHelper';
import FormInputWithClearButton from '@/components/FormInputWithClearButton/FormInputWithClearButton';
import InstallationModal from '@/components/InstallationModal/InstallationModal';
import DeviceUpgradeModal from '@/components/DeviceUpgradeModal/DeviceUpgradeModal';
import UninstallationModal from '@/components/UninstallationModal/UninstallationModal';
import InstallationIssues from '@/components/Device/InstallationIssues/InstallationIssues';
import InstallationLog from '@/components/Device/InstallationLog/InstallationLog';
import { deviceService } from "@/_services";
import ResponsiveTable from "@/components/ResponsiveTable/ResponsiveTable";

export default {
  name: 'Devices',
  components: {
    ResponsiveTable,
    FormInputWithClearButton,
    InstallationModal,
    DeviceUpgradeModal,
    UninstallationModal,
    InstallationIssues,
    InstallationLog
  },
  data() {
    return {
      sortBy: 'product_serial_num',
      sortDesc: false,
      isBusy: false,
      fields: [
        {
          key: 'product_serial_num',
          label: 'SERIAL',
          class: 'productSerialNum',
          sortable: true,
          sortDirection: 'asc',
        },
        {
          key: 'circuit',
          label: 'CIRCUIT',
          sortable: true,
          sortDirection: 'asc',
        },
        {
          key: 'pole_substation_name',
          label: 'SUBSTATION NAME',
          sortable: true,
          sortDirection: 'asc',
        },
        {
          key: 'device_last_message_time',
          label: 'LAST MESSAGE TIME',
          sortable: true,
          sortDirection: 'asc',
          formatter: datetimeFormatter
        },
        {
          key: 'actions',
          label: 'ACTIONS',
          class: 'actions_buttons'
        }
      ],
      searchableFields: [
          "product_serial_num",
          "circuit",
          'pole_substation_name',
          "device_last_message_time",
          "actions"
      ],
      search: '',
      deviceToInstall: null,
      deviceToUninstall: null,
      deviceToUpgrade: null,
      installationIssuesCount: 0,
      installationLogCount: 0
    }
  },
  computed: {
    ...mapGetters('device', ['devices']),
    ...mapState("layout", {
      hideInactiveCircuits: state => state.hideInactiveCircuits
    }),
    devicesUnNested() {
      return this.devices.map(d => {
        d.pole_substation_name = d.pole ? d.pole.pole_substation_name : null
        d.circuit = d.pole ? d.pole.circuit_name : null
        return d
    })
    }
  },
  watch: {
    hideInactiveCircuits(onlyActiveCircuits) {
      this.findAll(onlyActiveCircuits)
    }
  },
  methods: {
    ...mapActions('device', ['findAll']),
    ...mapActions('alert', ['error']),
    ...mapActions("dashboard", ["setSelectedDevice",]),
    datetimeFormatter,
    handleInstallModalReset: function() {
      this.deviceToInstall = null;
    },
    handleUninstallSuccess: function() {
      this.findAll(this.hideInactiveCircuits);
    },
    handleUninstallModalReset: function() {
      this.deviceToUninstall = null;
    },
    setSelectedDeviceForSentinelInstall: function(device) {
      this.deviceToInstall = device;
    },
    setSelectedDeviceForSentinelUninstall: function(device) {
      this.deviceToUninstall = device;
    },
    setSelectedDeviceForSentinelUpgrade: function(device) {
      this.deviceToUpgrade = device;
    },
    updateinstallationCounts: function () {
      deviceService.getInstallationCounts()
      .then(response => {
        this.installationIssuesCount = response.data.issues_count;
        this.installationLogCount = response.data.installation_log_count;
      })
      .catch(() => {
        this.error('Error getting Installation issues count');
      });
    }
  },
  mounted() {
    this.findAll(this.hideInactiveCircuits);
    this.updateinstallationCounts();
  },
};
</script>

<style src="./Devices.scss" lang="scss" />
